import { RosterStatus } from '__generated__/graphql'
import { Params, RouteObject } from 'react-router-dom'
import RosterMappings from './pages/RosterMappings'
import RosterMappingCandidateList from './pages/RosterMappings/CandidateList'
import RosterSearches from './pages/RosterSearchesOld'
import RosterSearchCandidateList from './pages/RosterSearchesOld/CandidateList'
import RosterSearchesNew from './pages/RosterSearches'
import RosterSearchCandidateListNew from './pages/RosterSearches/CandidateList'
import { clientRouteConfig } from './shared/routeTargets'

export interface SearchRouteParams extends Params {
    rosterStatus?: RosterStatus.Active | RosterStatus.Closed
}

export interface SearchCandidateListRouteParams extends Params {
    rosterId?: string
}

const ClientRoutes: RouteObject[] = [
    {
        path: `${clientRouteConfig.searches.path}`,
        element: <RosterSearches />,
    },
    {
        path: `${clientRouteConfig.searches.path}/:rosterId`,
        element: <RosterSearchCandidateList />,
    },
    {
        path: `${clientRouteConfig.searchesNew.path}`,
        element: <RosterSearchesNew />,
    },
    {
        path: `${clientRouteConfig.searchesNew.path}/:rosterId`,
        element: <RosterSearchCandidateListNew />,
    },
    {
        path: `${clientRouteConfig.mappings.path}`,
        element: <RosterMappings />,
    },
    {
        path: `${clientRouteConfig.mappings.path}/:rosterId`,
        element: <RosterMappingCandidateList />,
    },
]

export default ClientRoutes
